export const FETCH_ALLPARENTS_REQUEST = 'FETCH_ALLPARENTS_REQUEST'
export const FETCH_ALLPARENTS_SUCCESS = 'FETCH_ALLPARENTS_SUCCESS'
export const FETCH_ALLPARENTS_FALIURE = 'FETCH_ALLPARENTS_FALIURE'
